import { useEffect, useState } from "react";
import {
  Button,
  Column,
  Grid,
  // Select,
  // SelectItem,
  TableToolbar,
  // TableToolbarAction,
  TableToolbarContent,
  TableToolbarSearch,
  // TableToolbarMenu,
} from "@carbon/react";
import { Add } from "@carbon/react/icons";
import moment from "moment";
import { appConfig } from "../../configs";
import { filterConstants } from "../../constants";
import { useQueryString, useQueryStringFilter } from "../../hooks";

import { PeriodFilter, DatePopOver } from "../../components";
import { DateRangePicker } from "../DateRangePicker";
import { DateRangePickerCld } from "../DateRangePicker-CLD";
import { DateRangePickerGpt4 } from "../DateRangePicker-CLD/DateRangePicker-GPT4";

export const QuickTableToolbar = ({
  toolbarSearchStringValue,
  onToolbarSearchInputChange,
  defaultSearchValue,
  toolbarTabs,
  appendQueryStringPrefixWithTableId,

  // extra buttons
  extraButtons,
  onExport,
  openCreateNewModal,
  openCreateNewModalButton,
  createNewButtonText,
}) => {
  const query = useQueryString();
  const startDate = query.get(
    appendQueryStringPrefixWithTableId(filterConstants.startDateKey)
  );
  const endDate = query.get(
    appendQueryStringPrefixWithTableId(filterConstants.endDateKey)
  );

  console.log("query startDate in QuickTableToolbar: ", startDate);
  console.log("query endDate in QuickTableToolbar: ", endDate);

  const { seturlQueryStringFilter } = useQueryStringFilter([
    [
      appendQueryStringPrefixWithTableId(filterConstants.startDateKey),
      moment(startDate).format(appConfig.dateFormat1),
    ],
    [
      appendQueryStringPrefixWithTableId(filterConstants.endDateKey),
      moment(endDate).format(appConfig.dateFormat2),
    ],
  ]);

  const [startChartPeriod, setStartChartPeriod] = useState(
    moment(startDate) ||
      moment().subtract(1, "month").format(appConfig.dateFormat1)
  );

  const [endChartPeriod, setEndChartPeriod] = useState(
    moment(endDate) || moment().format(appConfig.dateFormat1)
  );

  useEffect(() => {
    if (startChartPeriod !== null) {
      console.log("startChartPeriod in QuickTableToolbar: ", startChartPeriod);
      seturlQueryStringFilter(
        {
          [appendQueryStringPrefixWithTableId(filterConstants.startDateKey)]:
            startChartPeriod || moment().format(appConfig.dateFormat1),
        },
        true
      );
    }

    if (endChartPeriod !== null) {
      console.log("endChartPeriod in QuickTableToolbar: ", endChartPeriod);
      seturlQueryStringFilter(
        {
          [appendQueryStringPrefixWithTableId(filterConstants.endDateKey)]:
            endChartPeriod || moment().format(appConfig.dateFormat1),
        },
        true
      );
    }
  }, [startChartPeriod, endChartPeriod]);

  // useEffect to set the correct start and end chart periods when the tab is changed
  useEffect(() => {
    // if (startDate !== null) {
    //   setStartChartPeriod(startDate);
    //   setEndChartPeriod(moment().format(appConfig.dateFormat1));
    // }
    if (startDate !== null) {
      setStartChartPeriod(moment(startDate).format(appConfig.dateFormat1));
    }
    if (endDate !== null) {
      setEndChartPeriod(moment(endDate).format(appConfig.dateFormat1));
    }
  }, [startDate, endDate]);

  const setStartChartPeriodFromDatePicker = (
    startDateToSet //: string | number | Date
  ) => {
    const formattedDateToSet = moment(startDateToSet).format(
      appConfig.dateFormat1
    );
    setStartChartPeriod(formattedDateToSet);
  };

  const setEndChartPeriodFromDatePicker = (
    endDateToSet //: string | number | Date
  ) => {
    const formattedDateToSet = moment(endDateToSet).format(
      appConfig.dateFormat1
    );
    setEndChartPeriod(formattedDateToSet);
  };

  return (
    <Grid>
      <Column sm={4} md={8} lg={16}>
        <TableToolbar>
          <TableToolbarContent>
            {toolbarTabs && toolbarTabs}

            <TableToolbarSearch
              className="search-table--md"
              defaultValue={defaultSearchValue}
              onChange={(evt) =>
                evt && onToolbarSearchInputChange(evt.target.value)
              }
              value={toolbarSearchStringValue}
              size="sm"
            />
            <TableToolbarSearch
              defaultExpanded={false}
              className="search-table--sm"
              defaultValue={defaultSearchValue}
              onChange={(evt) =>
                evt && onToolbarSearchInputChange(evt.target.value)
              }
              value={toolbarSearchStringValue}
              size="sm"
            />
            {/* 
            <span className="filter-text align-self--end pl-5 pr-5">
              Period:
            </span> */}

            {/* <div className="period-filter--container flex-container justify-content--end align-items--end no-wrap ml-3 mr-3">
              <div
                className="quicktable-period-filter"
                style={{ width: "90px" }}
              >
                <PeriodFilter
                  appendQueryStringPrefixWithTableId={
                    appendQueryStringPrefixWithTableId
                  }
                />
              </div>

              <div
                className="quicktable-date-popover"
                style={{ width: "200px" }}
              >
                <DatePopOver
                  name="period-select-datepicker"
                  label=""
                  startDate={startChartPeriod}
                  endDate={endChartPeriod}
                  setStartDate={setStartChartPeriodFromDatePicker}
                  setEndDate={setEndChartPeriodFromDatePicker}
                  className="quicktable-datepicker"
                />
                <DateRangePicker
                  name="period-select-datepicker"
                  label=""
                  startDate={startChartPeriod}
                  endDate={endChartPeriod}
                  setStartDate={setStartChartPeriodFromDatePicker}
                  setEndDate={setEndChartPeriodFromDatePicker}
                  className="quicktable-datepicker"
                />
                <DateRangePickerCld
                  name="period-select-datepicker"
                  label=""
                  startDate={startChartPeriod}
                  endDate={endChartPeriod}
                  setStartDate={setStartChartPeriodFromDatePicker}
                  setEndDate={setEndChartPeriodFromDatePicker}
                  className="quicktable-datepicker"
                />

                <DateRangePickerGpt4
                  name="period-select-datepicker"
                  label=""
                  startDate={startChartPeriod}
                  endDate={endChartPeriod}
                  setStartDate={setStartChartPeriodFromDatePicker}
                  setEndDate={setEndChartPeriodFromDatePicker}
                  className="quicktable-datepicker"
                />
              </div>
            </div> */}

            {extraButtons && extraButtons}

            {!onExport ? (
              <></>
            ) : (
              <></>
              // <Button
              //   onClick={onExport}
              //   size="sm"
              //   kind="tertiary"
              //   className="switchapp-themed export-button"
              //   iconDescription="Export"
              // >
              //   <ArrowUpRight size={18} className="export-button--icon" />
              //   Export
              // </Button>
            )}

            {openCreateNewModalButton ? (
              openCreateNewModalButton
            ) : !openCreateNewModal ? (
              <></>
            ) : (
              <Button
                onClick={openCreateNewModal}
                size="sm"
                className="switchapp-themed create-new-button"
                iconDescription="Create a new item"
              >
                <Add size={18} />
                {createNewButtonText || "Create New"}
              </Button>
            )}
          </TableToolbarContent>
        </TableToolbar>
      </Column>
    </Grid>
  );
};
